module.exports = __webpack_public_path__ + "static/media/workout1.8ba2061f.jpg";